import { Chats } from '../collections'

export const updateChatRoomFirebase = async (
  buildingId,
  roomId,
  responder,
  sender,
  lastMessage,
) => {
  await Chats.doc(`${buildingId}`).collection('channelsWithLastMessage').doc(roomId).update({
    updatedAt: new Date().toISOString(),
    responder,
    isRead: false,
    lastMessageSenderIDfromTeam: sender,
    closedAt: null,
    lastMessage,
  })
}

export const getSMScounter = async (buildingId) => {
  const currentChannel = (await Chats.doc(`${buildingId}`).get()).data()
  return currentChannel.SMSCounter
}

export const updateChatAssigneeFirebase = async (buildingId, roomId, assigneeId) => {
  await Chats.doc(`${buildingId}`).collection('channelsWithLastMessage').doc(roomId).update({
    updatedAt: new Date().toISOString(),
    assignee: assigneeId,
  })
}

export const updateChatClosedAtFirebase = async (buildingId, roomId, closedAt) => {
  await Chats.doc(`${buildingId}`).collection('channelsWithLastMessage').doc(roomId).update({
    updatedAt: new Date().toISOString(),
    closedAt: closedAt,
  })
}

export const getAllConversationsPerBuildingId = async (buildingId) => {
  try {
    const snapshot = await Chats.doc(`${buildingId}`).collection('channelsWithLastMessage').get()

    const currentBuildingConversations = snapshot.docs.map((doc) => ({
      name: doc.id,
      ...doc.data(),
    }))

    return currentBuildingConversations
  } catch (error) {
    console.error('Error getting conversations:', error)
    throw error
  }
}

export const readChatRoomFirebase = async (buildingId, roomId) => {
  const currentChannel = (
    await Chats.doc(`${buildingId}`).collection('channelsWithLastMessage').doc(roomId).get()
  ).data()

  const responder = currentChannel?.responder
  if (responder && ['PMT', 'FDC', 'MT', 'MTRQ'].includes(responder)) {
    await Chats.doc(`${buildingId}`).collection('channelsWithLastMessage').doc(roomId).update({
      isRead: true,
    })
  }
}
